// ----------------------------------------------------------------------
// <copyright file="Izenda.DividerAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var withState = require('recompose').withState;
  var setPropTypes = require('recompose').setPropTypes;
  var withProps = require('recompose').withProps;
  var onlyUpdateForKeys = require('recompose').onlyUpdateForKeys;
  const { curry, get } = require('lodash/fp');
  const DimensionUtils = require('share/utils/Izenda.DimensionUtils');

  var DividerAction = compose(
    withState('position', 'setPosition', { x: 0, y: 0 }),
    withState('newValue', 'setNewValue', 0),
    withState('domNode', 'setDomNode', null),
    withState('defaultValue', 'setDefaultValue', function(props) {
      return props.config.defaultValue;
    }),

    withProps(function(props) {
      var orientation =
        props.orientation === 'horizontal' ? { axis: 'x', type: 'width' } : { axis: 'y', type: 'height' };

      return {
        axis: orientation.axis,
        type: orientation.type
      };
    }),

    withHandlers({
      onStop: curry(onStop),
      onDrag: curry(onDrag)
    }),

    setPropTypes({
      orientation: React.PropTypes.string.isRequired,
      nodeHandle: React.PropTypes.string.isRequired,
      config: React.PropTypes.object.isRequired,
      afterMove: React.PropTypes.func
    }),

    onlyUpdateForKeys(['position'])
  );

  function onDrag(props, event, position) {
    var delta = position[props.axis];
    var unit = 'px';
    if (props.toViewPortDimension && props.orientation !== 'horizontal') {
      const dimension = DimensionUtils.px2vh(delta);
      delta = dimension.value;
      unit = dimension.unit;
    }
    var newValue = clampPosition(props, props.defaultValue + delta);
    var contentEl = get(props.nodeHandle, props.domNode);

    contentEl.style[props.type] = `${newValue}${unit}`;

    props.setNewValue(newValue);
  }

  function onStop(props, event) {
    props.setDefaultValue(props.newValue);

    props.setPosition({ x: 0, y: 0 });
    props.afterMove && props.afterMove();
  }

  function clampPosition(props, value) {
    var min = props.config.minValue;
    var max = props.config.maxValue;

    return Math.min(Math.max(value, min), max);
  }

  module.exports = DividerAction;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.DividerAction.js